const sumBy = (rows, getter) => (Array.isArray(rows) ? rows : []).reduce((acc, row) => acc + Number(getter(row) || 0), 0)

const avgBy = (rows, getter) => {
  const list = Array.isArray(rows) ? rows : []
  if (!list.length) return 0
  return sumBy(list, getter) / list.length
}

const getPlanSales = (row) => Number(row?.salesPlan ?? row?.sales_plan ?? row?.sales_monthly_plan ?? row?.salesMonthlyPlan ?? 0)
const getPlanMarkdown = (row) => Number(row?.markdownPlan ?? row?.markdown_plan ?? row?.markdown_plan_dollars ?? row?.markdowns_plan ?? 0)
const getPlanBom = (row) => Number(row?.planInvBOM ?? row?.inventory_bom_plan ?? row?.inventoryBomPlan ?? 0)
const getPlanInflowRetail = (row) => Number(row?.planInflowRetail ?? row?.inflow_retail_plan ?? row?.inflowRetailPlan ?? 0)
const getPlanInflowCost = (row) => Number(row?.planInflowCost ?? row?.inflow_cost_plan ?? row?.inflowCostPlan ?? 0)

const getActualSales = (row) => Number(row?.salesActual ?? row?.sales_actual ?? 0)
const getActualMarkdown = (row) => Number(row?.markdownActual ?? row?.markdown_actual ?? 0)
const getActualBom = (row) => Number(row?.actualInvBOM ?? row?.inventory_actual_bom ?? row?.inventoryActualBom ?? row?.inventory_bom_actual ?? row?.inventoryBomActual ?? 0)
const getActualStockToSales = (row) => {
  const direct = Number(
    row?.actualSS
    ?? row?.stock_to_sales_actual
    ?? row?.stockToSalesActual
    ?? row?.Actual_StockToSales
    ?? row?.actual_stock_to_sales
    ?? row?.rawTrendedStockToSales
    ?? row?.raw_trended_stock_to_sales
  )
  if (Number.isFinite(direct) && direct > 0) return direct
  const sales = getActualSales(row)
  const bom = getActualBom(row)
  return sales > 0 ? (bom / sales) : 0
}
const getActualInflowRetail = (row) => Number(row?.actualInflowRetail ?? row?.inflowRetailActual ?? row?.inflow_retail_actual ?? row?.inflowRetail ?? 0)
const getActualInflowCost = (row) => Number(row?.actualInflowCost ?? row?.inflowCostActual ?? row?.inflow_cost_actual ?? row?.inflowCost ?? 0)

const avgDefinedBy = (rows, getter) => {
  const list = (Array.isArray(rows) ? rows : [])
    .map((row) => Number(getter(row)))
    .filter((value) => Number.isFinite(value) && value > 0)
  if (!list.length) return null
  return list.reduce((acc, value) => acc + value, 0) / list.length
}

export const buildPlannerAnnualValues = ({ planRows = [], actualRows = null }) => {
  const plans = Array.isArray(planRows) ? planRows : []
  const actuals = Array.isArray(actualRows) ? actualRows : plans

  const annualSalesPlan = sumBy(plans, getPlanSales)
  const salesActualTotal = sumBy(actuals, getActualSales)
  const markdownPlanTotal = sumBy(plans, getPlanMarkdown)
  const markdownActualTotal = sumBy(actuals, getActualMarkdown)
  const avgPlanBom = avgBy(plans, getPlanBom)
  const avgActualBom = avgBy(actuals, getActualBom)
  const planInflowRetail = sumBy(plans, getPlanInflowRetail)
  const planInflowCost = sumBy(plans, getPlanInflowCost)
  const actualInflowRetail = sumBy(actuals, getActualInflowRetail)
  const actualInflowCost = sumBy(actuals, getActualInflowCost)
  const avgActualStockToSales = avgDefinedBy(actuals, getActualStockToSales)

  return {
    annualSalesPlan,
    linearSalesModel: null,
    calc1SalesModel: null,
    calc3SalesModel: null,
    salesAnnualPlanLM: null,
    annualMarkdownsPlan: annualSalesPlan ? (markdownPlanTotal / annualSalesPlan) * 100 : 0,
    annualMarkdownsL12: salesActualTotal ? (markdownActualTotal / salesActualTotal) * 100 : 0,
    trendedTurn: avgActualStockToSales ? (52 / avgActualStockToSales) : null,
    annualTurnPlan: avgPlanBom ? (annualSalesPlan / avgPlanBom) : 0,
    annualTurnActual: avgActualBom ? (salesActualTotal / avgActualBom) : 0,
    turnLm: null,
    imuPlan: planInflowRetail ? (1 - (planInflowCost / planInflowRetail)) * 100 : 0,
    imuActual: actualInflowRetail ? (1 - (actualInflowCost / actualInflowRetail)) * 100 : 0,
    imuLM: null,
  }
}
